import { Link } from 'react-router-dom';

const targetProducts = [
  {
    key: 'pro',
    name: 'MeVER Chair Pro v1.1',
    badge: 'FLAGSHIP',
    tagline: 'プロフェッショナルのための究極の座り心地',
    image: 'https://static.readdy.ai/image/05cd76bb9b80c0f39a77a9e694effa95/18555a65f21397adfed78720e8be08d7.png',
    currentPriceBlack: '¥123,200',
    currentPriceGray: '¥128,700',
    campaignPriceBlack: '¥97,900',
    campaignPriceGray: '¥99,900',
    reservePriceBlack: '¥88,110',
    reservePriceGray: '¥89,910',
    savingsBlack: '¥25,300',
    savingsGray: '¥28,800',
    purchaseLink: 'https://mever.design/products/mever-chair-pro',
    highlights: ['4Dヘッドレスト', '6Dアームレスト', '135°リクライニング', '5年保証'],
  },
  {
    key: 'style',
    name: 'MeVER Chair Style v1.0',
    badge: 'MINIMAL',
    tagline: '空間と調和するデザイン',
    image: 'https://static.readdy.ai/image/05cd76bb9b80c0f39a77a9e694effa95/0e5886a34ba8b9935f350bf408063f8e.png',
    currentPriceBlack: '¥69,300',
    currentPriceGray: '¥71,500',
    campaignPriceBlack: '¥59,400',
    campaignPriceGray: '¥59,400',
    reservePriceBlack: '¥53,460',
    reservePriceGray: '¥53,460',
    savingsBlack: '¥9,900',
    savingsGray: '¥12,100',
    purchaseLink: 'https://mever.design/products/mever-chair-style',
    highlights: ['ミニマルモダンデザイン', '3Dアームレスト', 'ファブリックシート', 'ロッキング機能'],
  },
];

export default function CampaignProducts() {
  return (
    <section className="py-20 sm:py-28 md:py-36 bg-gradient-to-b from-gray-50 to-white" aria-labelledby="campaign-products-heading">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-14 sm:mb-20">
          <span className="inline-flex items-center gap-2 px-4 py-2 bg-black/5 text-black/60 text-xs sm:text-sm font-light tracking-[0.15em] rounded-full mb-5 sm:mb-6">
            TARGET PRODUCTS
          </span>
          <h2 id="campaign-products-heading" className="text-3xl sm:text-4xl md:text-5xl font-extralight text-black mb-4 tracking-[0.08em]">
            対象製品
          </h2>
          <p className="text-sm sm:text-base font-extralight text-black/50 tracking-wide max-w-xl mx-auto">
            MeVER Chair Pro と Style が本キャンペーンの対象です
          </p>
        </div>

        {/* Product Cards */}
        <div className="grid md:grid-cols-2 gap-6 sm:gap-8 md:gap-10">
          {targetProducts.map((product) => (
            <article
              key={product.key}
              className="group bg-white rounded-2xl sm:rounded-3xl overflow-hidden border border-gray-100 hover:border-[#E8B4B8]/30 transition-all duration-500 hover:shadow-xl hover:shadow-black/5"
            >
              {/* Image */}
              <div className="relative aspect-[4/3] bg-gray-50 overflow-hidden">
                <img
                  src={product.image}
                  alt={`${product.name} - ${product.tagline}`}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-700"
                  loading="lazy"
                  width="600"
                  height="450"
                />
                <div className="absolute top-4 left-4 flex gap-2">
                  <span className="px-3 py-1.5 bg-black/80 text-white text-[10px] sm:text-xs font-medium tracking-widest rounded">
                    {product.badge}
                  </span>
                  <span className="px-3 py-1.5 bg-[#C4787A] text-white text-[10px] sm:text-xs font-medium tracking-wide rounded flex items-center gap-1">
                    <i className="ri-fire-line text-xs" aria-hidden="true"></i>
                    キャンペーン対象
                  </span>
                </div>
              </div>

              {/* Content */}
              <div className="p-6 sm:p-8">
                <h3 className="text-xl sm:text-2xl font-light text-black mb-1.5 tracking-wide">
                  {product.name}
                </h3>
                <p className="text-sm font-extralight text-black/50 mb-6 tracking-wide">{product.tagline}</p>

                {/* Highlights */}
                <div className="flex flex-wrap gap-2 mb-6">
                  {product.highlights.map((h) => (
                    <span key={h} className="px-3 py-1.5 bg-gray-50 text-xs font-light text-black/60 rounded-full tracking-wide">
                      {h}
                    </span>
                  ))}
                </div>

                {/* Price Comparison Table */}
                <div className="bg-gradient-to-br from-[#FFFAF7] to-[#FFF5F0] rounded-xl p-5 sm:p-6 mb-6 border border-[#E8B4B8]/10">
                  <div className="grid grid-cols-3 gap-3 text-center mb-4">
                    <div className="text-xs font-light text-black/40 tracking-wide"></div>
                    <div className="text-xs font-light text-black/40 tracking-wide">Black</div>
                    <div className="text-xs font-light text-black/40 tracking-wide">Gray</div>
                  </div>

                  {/* Current (post-increase) price */}
                  <div className="grid grid-cols-3 gap-3 items-center py-2.5 border-b border-[#E8B4B8]/10">
                    <span className="text-xs font-light text-black/50 tracking-wide">値上げ後価格</span>
                    <span className="text-sm text-black/40 line-through text-center">{product.currentPriceBlack}</span>
                    <span className="text-sm text-black/40 line-through text-center">{product.currentPriceGray}</span>
                  </div>

                  {/* Campaign price */}
                  <div className="grid grid-cols-3 gap-3 items-center py-2.5 border-b border-[#E8B4B8]/10">
                    <span className="text-xs font-medium text-[#C4787A] tracking-wide">キャンペーン価格</span>
                    <span className="text-base sm:text-lg font-medium text-[#C4787A] text-center">{product.campaignPriceBlack}</span>
                    <span className="text-base sm:text-lg font-medium text-[#C4787A] text-center">{product.campaignPriceGray}</span>
                  </div>

                  {/* Reserve price */}
                  <div className="grid grid-cols-3 gap-3 items-center py-2.5">
                    <span className="text-xs font-medium text-amber-600 tracking-wide">予約価格（10%OFF）</span>
                    <span className="text-base sm:text-lg font-medium text-amber-600 text-center">{product.reservePriceBlack}</span>
                    <span className="text-base sm:text-lg font-medium text-amber-600 text-center">{product.reservePriceGray}</span>
                  </div>
                </div>

                {/* Savings badge */}
                <div className="flex items-center gap-2 mb-6">
                  <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-[#C4787A]/10 text-[#C4787A] text-xs sm:text-sm font-medium rounded-full">
                    <i className="ri-arrow-down-line text-sm" aria-hidden="true"></i>
                    最大 {product.savingsBlack} おトク（購入時）
                  </span>
                </div>

                {/* CTAs */}
                <div className="flex flex-wrap gap-3">
                  <a
                    href={product.purchaseLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 px-6 sm:px-7 py-3 bg-[#C4787A] text-white text-sm font-light tracking-wide hover:bg-[#B06A6C] transition-colors whitespace-nowrap rounded-md cursor-pointer"
                    aria-label={`${product.name}を購入する（外部サイト）`}
                  >
                    <i className="ri-shopping-cart-line text-sm" aria-hidden="true"></i>
                    購入する
                  </a>
                  <Link
                    to={`/chair/${product.key}`}
                    className="inline-flex items-center gap-2 px-6 sm:px-7 py-3 border border-black/15 text-black/70 text-sm font-light tracking-wide hover:bg-black hover:text-white transition-all whitespace-nowrap rounded-md cursor-pointer"
                    aria-label={`${product.name}の詳細ページへ`}
                  >
                    製品詳細
                    <i className="ri-arrow-right-line text-sm" aria-hidden="true"></i>
                  </Link>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
